<ng-container>
<div *ngIf="!serviceDateExpired()" class="screen-element dashboard-idle">
	<div class="left-side">
		<div class="idle-iconbar">
			<iconbar [classes]="'idle'"></iconbar>
		</div>	
		<div class="idle-dashboard-center">
			<div class="value">{{indoorTempSensor.getCurrentValue()}}</div>
			<div class="unit">{{indoorTempSensor.getUnit()}}</div>
		</div>
		<div class="text text-1">{{getTranslator().tr("IDLE_COCKPIT_ROOM_TEMPERATURE_1")}}</div>
		<div class="text text-2">{{getTranslator().tr("IDLE_COCKPIT_ROOM_TEMPERATURE_2")}}</div>
	</div>
	<div class="right-side">
		<div class="value value-1">{{getIoService().getCurrentTime()| date: "HH:mm"}}</div>
		<div class="text text-1">{{getTranslator().tr("IDLE_COCKPIT_TIME")}}</div>
		<div *ngIf="hasHumiditySensor" class="value value-1">{{humiditySensor.getCurrentValue()}} %</div>
		<div *ngIf="hasHumiditySensor" class="text text-1">{{getTranslator().tr("IDLE_COCKPIT_HUMIDITY")}}</div>

		
		<div *ngIf="desiredTemp" class="value value-1">{{desiredTemp.toString()}}</div>
		<div *ngIf="desiredTemp" class="text text-1">{{getTranslator().tr("IDLE_COCKPIT_DESIRED_TEMPERATURE")}}</div>
		<div *ngIf="hasOutdoorTempSensor" class="value value-1">{{outdoorTempSensor.toString()}}</div>
		<div *ngIf="hasOutdoorTempSensor" class="text text-1">
		{{getTranslator().tr("IDLE_COCKPIT_OUTSIDE_TEMPERATURE")}}</div>
	</div>
</div>
<div *ngIf="serviceDateExpired()" class="screen-element dashboard-service">
	<div class="screen-element toast-screen">
		<div class="dashboard-center">
			<div class="icon iconCompetentPersonInstaller"></div>
		</div>
		<div class="text text-1"><text-widget [color]="'white'" [text]="getTranslator().tr('OTX_MAINTENANCE_3_1')"></text-widget></div>
		<div class="text text-2"><text-widget [color]="'white'" [text]="getTranslator().tr('OTX_MAINTENANCE_3_2')"></text-widget></div>
		<div class="text text-3"><text-widget [color]="'white'" [text]="serviceCompany"></text-widget></div>
		<div class="text text-4"><text-widget [color]="'white'" [text]="servicePhoneNumber"></text-widget></div>

	</div>
</div>
</ng-container>